/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  createCriteria,
  updateCriteria,
  deleteCriteria,
  fetchCriteria,
  fulfillCriteria,
  unfulfillCriteria
} from '../../actions/criteriaActions';
import { allows } from '../../utils/authorization';
import expandIcon from '../../../assets/images/expandArrows.png';
import collapseIcon from '../../../assets/images/collapseArrows.png';

class ProductSuccessCriteria extends React.Component {
  constructor(props) {
    super(props);

    this.state = { textInput: props.detailCard, acInput: '' };
  }

  componentDidMount() {
    if (!this.props.isNew)
      this.props.fetchCriteria(this.props.product.id, 'success');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product && !this.props.isNew) {
      this.props.fetchCriteria(this.props.product.id, 'success');
    }
  }

  focusInput = () => this.input && this.input.focus();

  handleChange = (event) => {
    this.setState({ acInput: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { acInput, edit } = this.state;
    const { isNew, addCriteria, product } = this.props;
    if (isNew) {
      if (!acInput) return null;
      addCriteria({
        type: 'success',
        short_name: acInput,
        tempId: edit
      });
      this.setState({ acInput: '', textInput: true, edit: undefined });
      return null;
    }

    const payload = {
      product_id: product.id,
      type: 'success',
      criterion: {
        short_name: acInput
      }
    };

    if (payload.criterion.short_name.length > 0) {
      const editId = edit;
      this.setState({ acInput: '', edit: undefined });

      if (this.props.detailCard)
        this.setState({ acInput: '', textInput: true, edit: undefined });

      return editId
        ? this.props.updateCriteria(editId, payload, 'success')
        : this.props.createCriteria(payload, 'success');
    }

    return null;
  };

  handleFulfillCheck = (criterium) => {
    const { product } = this.props;

    if (criterium.fulfilled) {
      this.props.unfulfillCriteria(criterium.id, 'success', {
        product_id: product.id
      });
    } else {
      this.props.fulfillCriteria(criterium.id, 'success', {
        product_id: product.id
      });
    }
  };

  handleEdit = ({ id, tempId, short_name: shortName }) => {
    this.setState({ textInput: true, edit: id || tempId }, () => {
      this.input.value = shortName;
      this.focusInput();
    });
  };

  handleDelete = (criterium, index) => {
    const { isNew, removeCriteria } = this.props;
    if (isNew) {
      removeCriteria(index);
      return;
    }
    this.props.deleteCriteria(criterium, 'success');
  };

  showTextInput = () => {
    this.setState({ textInput: true }, () => this.focusInput());
  };

  render() {
    const {
      criteria,
      index,
      product,
      detailCard,
      isNew,
      isCriteriaFull,
      toggleCriteriaFull
    } = this.props;
    const { edit } = this.state;
    const allowEdit = product.id ? allows('update', product, 'product') : true;
    const allowDelete = product.id
      ? allows('destroy', product, 'product')
      : true;

    let divStyle = index % 2 === 0 ? 'gray-bg' : 'white-bg';
    if (detailCard)
      divStyle = `acceptance-criteria ${
        isCriteriaFull ? 'acceptance-criteria-full' : ''
      }`;

    return (
      <>
        {detailCard && (
          <label htmlFor="acceptance-criteria">Success Criteria</label>
        )}
        <div className={divStyle}>
          <div
            className={`acceptance-criteria-list ${
              isCriteriaFull ? 'acceptance-criteria-list-full' : ''
            }`}
          >
            <img
              src={isCriteriaFull ? collapseIcon : expandIcon}
              className={`resize-btn ${isCriteriaFull ? 'full' : ''}`}
              onClick={toggleCriteriaFull}
            />
            {criteria.map((criterium, ind) => (
              <div className="criteria-row" key={criterium.id || ind}>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.handleDelete(criterium, ind)}
                  disabled={!allowDelete}
                >
                  <span className="glyphicon glyphicon-minus red" />
                </button>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.handleEdit(criterium)}
                  disabled={!allowEdit}
                >
                  <span className="glyphicon glyphicon-pencil" />
                </button>

                {!isNew && (
                  <button
                    type="button"
                    className={`btn ${criterium.fulfilled && 'fulfilled'}`}
                    onClick={() => this.handleFulfillCheck(criterium)}
                    disabled={!allowEdit}
                  >
                    <span className="glyphicon glyphicon-ok" />
                  </button>
                )}

                <span
                  className={`criteria-name ${
                    criterium.fulfilled && 'fulfilled'
                  }`}
                >
                  {criterium.short_name}
                </span>
              </div>
            ))}
          </div>
          {this.state.textInput && (
            <form
              className="form-inline acceptance-criteria-input"
              onSubmit={this.handleSubmit}
            >
              <span className="input-with-loading">
                {/* there is no loader present as this span is being used for styling purposes */}
                <input
                  value={this.state.acInput}
                  disabled={!allowEdit}
                  onChange={this.handleChange}
                  ref={(input) => {
                    this.input = input;
                  }}
                />
              </span>
              <button
                type="submit"
                className="btn btn-xs button-lavender"
                disabled={!allowEdit}
              >
                <strong>{edit ? 'SAVE' : 'ADD'} SC</strong>
              </button>
            </form>
          )}
        </div>
      </>
    );
  }
}

ProductSuccessCriteria.propTypes = {
  detailCard: PropTypes.bool,
  source: PropTypes.string,
  product: PropTypes.object,
  index: PropTypes.number,
  criteria: PropTypes.array,
  createCriteria: PropTypes.func,
  updateCriteria: PropTypes.func,
  deleteCriteria: PropTypes.func,
  fetchCriteria: PropTypes.func,
  fulfillCriteria: PropTypes.func,
  unfulfillCriteria: PropTypes.func
};

const mapStateToProps = (state, ownProps) => ({
  criteria: ownProps.isNew
    ? ownProps.criteria
    : state.criteriaReducer.criteria.success[ownProps.product.id] || []
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createCriteria,
      updateCriteria,
      deleteCriteria,
      fetchCriteria,
      fulfillCriteria,
      unfulfillCriteria
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductSuccessCriteria);
